var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techs"},[_c('h4',[_vm._v("Techs")]),_c('ul',[_vm._l((_vm.skills),function(skill){return [_c('li',{key:skill},[_c('Tech',{attrs:{"skill":skill}})],1)]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }